import YMain from './src/main'

YMain.install = function(Vue) {
  Vue.component(YMain.name, YMain)
}

export default YMain
